import React from 'react';
import { Row, Col } from 'antd';
import FloatingContainer from './floatingContainer'
import FadeDownWhileInView from './fadeDownWhileInView'
import { FiCheckCircle } from "react-icons/fi";

const FeatureListSection = () => {

  const renderCheckmark = (text) => {
    return (
      <Row align="middle" gutter={[10,10]} className="mt-10 flex-medium-center">
        <Col flex={0}>
          <div className="display-flex">
            <FiCheckCircle size={20} color="#536DFE"/>
          </div>
        </Col>
        <Col flex={0}>
          <div className="fs-14 fw-500">{text}</div>
        </Col>
      </Row>
    )
  }

  const renderFeatureListHeader = (text) => {
    return (
      <Row align="middle" gutter={[10,10]} className="mt-10">
        <Col flex={1}>
          <div className="fs-18 fw-700">{text}</div>
        </Col>
      </Row>
    )
  }

  const renderSpacer = () => {
    return (
      <div className="mt-30"></div>
    )
  }

  return (
    <>
      <FloatingContainer className="bg-blue-gradient" verticalPadding={60} maxWidth={1000}>
        <FadeDownWhileInView className="fs-30 fw-700 text-center c-white">Feature List</FadeDownWhileInView>
      </FloatingContainer>
      <FloatingContainer className="bg-white" verticalPadding={50} maxWidth={1000}>
        <Row gutter={[30,0]} className="medium-center">
          <Col xs={24} md={12}>
            <FadeDownWhileInView className="p-20">
              { renderFeatureListHeader("Events") }
              { renderCheckmark("Event Templates") }
              { renderCheckmark("Track Events Through Stages") }
              { renderCheckmark("Customize Client Permissions") }
              { renderCheckmark("Assign Packages & Add-Ons") }
              { renderCheckmark("Assign Staff Members") }
              { renderCheckmark("Detailed vs. List View") }
              { renderCheckmark("Upload Event Photo") }
              { renderSpacer() }

              { renderFeatureListHeader("Music") }
              { renderCheckmark("Search Spotify & Apple Music") }
              { renderCheckmark("Import Spotify Playlists") }
              { renderCheckmark("Default Recommended Playlists") }
              { renderCheckmark("Customize Recommended Playlists") }
              { renderCheckmark("Add Notes to Selected Songs") }
              { renderCheckmark("Export Music to File") }
              { renderCheckmark("PDF Download of Music Selections") }
              { renderSpacer() }

              { renderFeatureListHeader("Calendar") }
              { renderCheckmark("iCal Integration") }
              { renderCheckmark("View Events & Time Off Requests") }
              { renderSpacer() }

              { renderFeatureListHeader("Contracts") }
              { renderCheckmark("Contract Templates") }
              { renderCheckmark("Auto-Populate Contract Fields") }
              { renderCheckmark("E-Signature") }
              { renderCheckmark("Track Contracts by Status") }
              { renderCheckmark("Email Confirmations") }
              { renderCheckmark("PDF Download") }
              { renderSpacer() }

              { renderFeatureListHeader("Invoices") }
              { renderCheckmark("Generic Payment Links") }
              { renderCheckmark("Track Invoices by Status") }
              { renderCheckmark("PDF Download") }
              { renderSpacer() }

              { renderFeatureListHeader("Reports") }
              { renderCheckmark("Event Reports") }
              { renderCheckmark("Music Reports") }
              { renderCheckmark("Financial Reports") }
            </FadeDownWhileInView>
          </Col>
          <Col xs={24} md={12}>
            <FadeDownWhileInView className="p-20">
              { renderFeatureListHeader("Client Portal") }
              { renderCheckmark("Event Countdown") }
              { renderCheckmark("View Assigned Staff") }
              { renderCheckmark("Select Special Event Songs") }
              { renderCheckmark("Build Playlists") }
              { renderCheckmark("Create a Timeline") }
              { renderCheckmark("Answer Questionnaires") }
              { renderCheckmark("View Booked Services") }
              { renderCheckmark("View Contracts & Invoices") }
              { renderCheckmark("Switch Between Events") }
              { renderSpacer() }

              { renderFeatureListHeader("Multi-Op Support") }
              { renderCheckmark("Manage Staff Members") }
              { renderCheckmark("Customize Permissions") }
              { renderCheckmark("Approve / Reject Time Off Requests") }
              { renderCheckmark("View All Company Events") }
              { renderSpacer() }

              { renderFeatureListHeader("Account Settings") }
              { renderCheckmark("Select Date / Time Format, Tax Rate, and Currency") }
              { renderCheckmark("Customize Event Types") }
              { renderCheckmark("Customize Staff Event Roles") }
              { renderCheckmark("Customize Client Event Roles") }
              { renderCheckmark("Customize Genres") }
              { renderCheckmark("Upload Company Photo") }
              { renderCheckmark("Export Data") }
              { renderSpacer() }

              { renderFeatureListHeader("Sales Tools") }
              { renderCheckmark("Pricing Guides") }
              { renderCheckmark("Contact Forms") }
              { renderCheckmark("Manage Booking Requests") }
              { renderSpacer() }

              { renderFeatureListHeader("Notifications") }
              { renderCheckmark("Push Notifications") }
              { renderCheckmark("Email Notifications") }
            </FadeDownWhileInView>
          </Col>
        </Row>
      </FloatingContainer>
    </>
  );
};

export default FeatureListSection;
